module.exports = __webpack_public_path__ + "529321895d206af4355c7ae5110ec494.fbx";